

import React from "react";
import { Layout } from "antd";

import { Levels } from "./Levels.js";
import { LevelSettings } from "./LevelSettings";

const { Content, Sider } = Layout;
export const LevelBaseView = () => {
  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Sider
            width={550}
            
             style={{ background: "#fff", paddingLeft: "20px", width: "30%" }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <Levels/>
                </div>
              </div>
            </div>
          </Sider>
          <Content>
         <LevelSettings/>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

